/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/** The signed-in person's certificates, read once and shared by the page and the Profile card. */

import { useQuery } from '@tanstack/react-query';
import { fetchMyCertificates } from '../../../components/athlohive/myCertificates';

export const MY_CERTIFICATES_KEY = ['myCertificates'];

export default function useMyCertificates() {
  return useQuery({
    queryKey: MY_CERTIFICATES_KEY,
    queryFn: fetchMyCertificates,
    staleTime: 60 * 1000,
    // A sign-in problem is answered by the session dialog, not by retrying.
    retry: (count, error) => error?.kind !== 'auth' && count < 1,
  });
}
